import React, { useState, useEffect, useRef } from 'react';
import Cards from '../cards/cards';
import styles from "./projects.module.scss";

const ProjectCard = ({ project }) => {
    const [isFlipped, setIsFlipped] = useState(false);

    return (
        <div 
            className={styles.projects_card}
            onClick={() => setIsFlipped(!isFlipped)}
            onKeyPress={(e) => e.key === 'Enter' && setIsFlipped(!isFlipped)}
            tabIndex={0}
            role="button"
            aria-label={`Project: ${project.heading}`}
        >
            <div className={`${styles.projects_card_inner} ${isFlipped ? styles.flipped : ''}`}>
                <div className={styles.projects_card_front}>
                    <h3>{project.heading}</h3>
                    <div className={styles.tech_stack}>
                        {project.technologies.map((tech, index) => (
                            <span key={index}>{tech}</span>
                        ))}
                    </div>
                    <div className={styles.buttons}>
                        {project.repo && (
                            <a href={project.repo} target="_blank" rel="noopener noreferrer">
                                GitHub
                            </a>
                        )}
                        {project.link && (
                            <a href={project.link} target="_blank" rel="noopener noreferrer">
                                Live Demo
                            </a>
                        )}
                    </div>
                </div>
                <div className={styles.projects_card_back}>
                    <p>{project.description}</p>
                </div>
            </div>
        </div>
    );
};

const Projects = () => {
    const [typedText, setTypedText] = useState('');
    const fullText = 'Projects.';
    const sectionRef = useRef(null);
    const typingIntervalRef = useRef(null); // Use a ref to store the interval ID

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setTypedText(''); // Reset the text when the section comes into view
                    let index = 0;
                    clearInterval(typingIntervalRef.current); // Clear any existing interval
                    typingIntervalRef.current = setInterval(() => {
                        if (index < fullText.length) {
                            setTypedText(fullText.slice(0, index + 1)); // Use slice to avoid undefined values
                            index++;
                        } else {
                            clearInterval(typingIntervalRef.current);
                        }
                    }, 150);
                }
            },
            { threshold: 0.3 } // Adjusted threshold to trigger earlier
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
            clearInterval(typingIntervalRef.current); // Clear interval on component unmount
        };
    }, []);

    const ProjectsData = [
        {
            heading: "AI Resume Builder",
            description: "Built a full-stack platform that lets users input their career details through dynamic forms, uses AI to auto-enhance or complete missing sections, and then allows exporting professional PDFs or sharing personalized portfolio links.",
            technologies: ["NestJS", "React", "TypeScript", "Tailwind CSS", "MongoDB", "JWT", "LLM"],
            repo: "https://github.com/mansi2804/AI-Resume-Builder"
        },
        {
            heading: "Blogging Platform – AI-Powered Community Engagement",
            description: "Built a role-based blogging platform using React and TypeScript with OpenAI-driven auto-replies, Elasticsearch for scalable content search, and Material UI for clean UI/UX. Deployed with Docker, it delivers fast, personalized experiences and boosts user engagement.",
            technologies: ["React", "TypeScript", "OpenAI API", "Material UI", "Elasticsearch", "Docker", "UI/UX", "Role-Based Auth"],
            repo: "https://github.com/mansi2804/blogging-platform"
        },
        {
            heading: "Indian Vendors – Centralized Vendor Platform",
            description: "Built a web portal during the pandemic using Angular and Firebase to help vendors list and manage products. Included sentiment analysis to filter user comments and an admin dashboard for vendor control.",
            technologies: ["Angular12", "JavaScript", "Firebase", "HTML5", "CSS3", "Bootstrap4"],
            repo: "https://github.com/mansi2804/Indian-Vendors"
        },
        
        {
            heading: "CarePathway – Doctor-Patient Healthcare Portal",
            description: "Developed a responsive healthcare platform with appointment booking, doctor profiles, and searchable services. Built using React.js, Tailwind CSS, and Vite, it improves doctor-patient interaction and streamlines medical service discovery.",
            technologies: ["React.js", "Tailwind CSS", "Vite", "JavaScript", "HTML5", "CSS3", "UI/UX"],
            repo: "https://github.com/mansi2804/CarePathway",
            link: "https://care-pathway-gray.vercel.app/"
        },
        {
            heading: "Sentiment Analysis Web App",
            description: "Created a real-time sentiment analysis tool using React.js and Flask. Integrated machine learning for text classification and visualized results with interactive charts to enhance user understanding.",
            technologies: ["React.js", "Flask", "Python", "Machine Learning", "Data Visualization", "HTML", "CSS", "JavaScript", "UI/UX", "Version Control"],
            repo: "https://github.com/mansi2804/Sentiment_Analysis-"
        },
        
        {
            heading: "Real-Time Song/Artist Recommendation System",
            description: "Built a Spark Streaming-based recommendation engine using PySpark and MLlib to deliver real-time music suggestions based on user listening behavior and history. Focused on scalable data ingestion and personalized results.",
            technologies: ["Apache Spark", "PySpark", "SQL", "MLlib", "Python", "Big Data", "Data Visualization"],
            repo: "https://github.com/mansi2804/CSP554-BiGDATATECHNOLOGY_MANSIPATIL_FINALPROJECT"
        },
        
        {
            heading: "Weather Forecasting",
            description: "Developed a Weather Forecasting application using React.js and Material-UI.The application allows users to search for weather forecasts by city name, providing detailed predictions for the next 5-6 days at 3-hour intervals. simplifies weather tracking and planning, providing users with precise weather insights for effective decision-making",
            technologies: ["ReactJS", "Javascript", "MaterialUI", "Html5","  CSS3"],
            repo: "https://github.com/mansi2804/Weather-Forecasting",
            link: "https://weather-forecasting-bymansi.vercel.app/",
        },
        {
            heading: "eCommerce Website",
            description: "Built a full-featured eCommerce platform with product listings, user auth, cart, and secure checkout. Designed responsive UI to ensure seamless shopping and applied best practices for scalable web app deployment.",
            technologies: ["HTML5", "CSS3", "JavaScript", "UI/UX", "Version Control"],
            repo: "https://github.com/mansi2804/eCommerce-Website"
        },
        
     
        
     
    
    ]
    return (
        <section id="projects" ref={sectionRef} className={styles.projects}>
            <div className={`xl:mt-12 flex xl:flex-row flex-col-reverse gap-10 justify-left overflow-hidden `}>
                <div className={`flex-[0.6] p-10 md:p-16 lg:p-20 rounded-2xl`}>
                <h2 className={`main_color ${styles.typing}`}>{typedText}</h2>
                    <div className={`text-lg`}>
                        Following are some projects and Websites I worked on that showcase my skills I gained throughout my education and professional experience. It reflects my ability to solve complex problems, work with different technologies, and manage projects effectively.
                    </div>
                </div>
            </div>
            <div className={` p-10 md:p-16 lg:p-20 md:pt-0 lg:pt-0 pt-0 `+styles.projects_container}>
                {ProjectsData.map((project, index) => {
                    return (
                        <ProjectCard key={index} project={project} />
                    )
                })
                }
            </div>
        </section>
    )
}

export default Projects;
